import { render, staticRenderFns } from "./Load-custom.vue?vue&type=template&id=63f3b9a8&scoped=true"
import script from "./Load-custom.vue?vue&type=script&lang=js"
export * from "./Load-custom.vue?vue&type=script&lang=js"
import style0 from "./Load-custom.vue?vue&type=style&index=0&id=63f3b9a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f3b9a8",
  null
  
)

export default component.exports